import React from 'react';
import EcoClass122023 from 'views/EcoClass122023';

const AccountGeneralPage = () => {
  return <EcoClass122023/>;
};

export default AccountGeneralPage;
